<template>
    <div class="firm-set-info">
        <div class="title-box">
            <div class="back" @click="goBack">返回</div>
            <div class="line"></div>
            <div class="title">律所权益授权设置</div>
        </div>
        <div class="claimed-box">
            <div class="claimed-in-month">
                <div class="title">
                    律所线索权益额度
                    <div class="number">
                        {{ vipInfo.clue_quota || 0 }}
                    </div>
                </div>
            </div>
            <div class="claimed-in-month">
                <div class="title">
                    律所内容权益额度
                    <div class="number">
                        <span class="info-msg-num-value">
                            {{ vipInfo.content_quota || 0 }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="claimed-in-month">
                <div class="title">
                    律师尊享权益
                    <!-- eslint-disable -->
                    <img
                        ref="tip"
                        class="icon"
                        src="../../../assets/img/law/question.svg"
                        alt=""
                    />
                    <div class="number">
                        <span class="info-msg-num-value">
                            {{ vipInfo.aladdin_quota || 0 }}
                        </span>
                    </div>
                    <veui-popover target="tip" position="bottom-center">
                        <span class="help-text">至尊会员包含1名成员律师尊享权益，获得授权的成员将可以在百度搜索中获得优先推荐及律师专属名片卡展现，彰显权威。</span>
                    </veui-popover>
                    <!-- eslint-enable -->
                </div>
            </div>
            <!-- 开通了本地之星才展示 -->
            <div class="claimed-in-month" v-if="localStarInfo && localStarInfo.length">
                <local-star-box :local-star-info="localStarInfo"/>
            </div>
        </div>
    </div>
</template>
<script>
import 'veui-theme-dls-icons';
import {Popover} from 'veui';
import localStarBox from '@/components/localStarBox.vue';
import {mapState} from 'vuex';
/**
 * @file loading
 * @author liusihao
 */

export default {
    components: {
        'veui-popover': Popover,
        'local-star-box': localStarBox
    },
    computed: {
        ...mapState({
            vipInfo: state => state.lawStore?.vipInfo?.business_privilege_info || {}
        })
    },
    props: {
        // 本地之星数据
        localStarInfo: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    methods: {
        goBack() {
            this.$router.back();
        }
    }
};
</script>
<style lang="stylus" scoped>
.firm-set-info
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    .title-box
        display: flex;
        align-items: center;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #333;
        padding-bottom: 30px;
        border-bottom: 1px solid #e9ecf3;
        .back
            position: relative;
            padding-left: 12px;
            margin-left: 30px;
            cursor: pointer;
            &::before
                content: '';
                position: absolute;
                height: 12px;
                width: 10px;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                background: url(https://lvlin-base.cdn.bcebos.com/bend/back-icon.png) no-repeat center center / 100% 100%;
        .line
            width: 1px;
            height: 10px;
            background: #9d9d9d;
            margin: 0 12px;
    .claimed-box
        display: flex
        margin-top: 24px;
        padding: 0 30px;
        .claimed-in-month
            width: 342px;
            min-height: 97px;
            background: #f6f8f9;
            border-radius: 8px;
            padding: 24px 24px 22px;
            .title
                font-family: PingFangSC-Regular;
                font-size: 13px;
                color: #333;
                line-height: 14px;
                .icon
                    width: 14px;
                    height: 14px;
                    margin-left: 3px;
                    vertical-align: bottom;
                    cursor: pointer;
            .number
                font-family: HelveticaNeue-Bold;
                font-size: 28px;
                color: #282c33;
                line-height: 28px;
                font-weight: 700;
                margin-top: 8px;
        .claimed-in-month:not(:last-child)
            margin-right: 16px;
</style>
